module.exports = require('./src/video-worker.esm');
